/**
 * 复制到剪贴板的方法
 */
import main from '../../main';
const copy = (item, valueName, showMsg = true) => {
        let data = item[valueName] ? item[valueName] : item;
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand('Copy'); // 执行浏览器复制命令
        showMsg && main.$message.success({message: 'Copied', center: true});
        oInput.remove();
};
export default copy;